// FILTER_NAME_CONSTANTS
export const ENTITY_TYPE_FILTER = "ENTITY_TYPE_FILTER";
export const TEXTUAL_SEARCH_IMAGE = "TEXTUAL_SEARCH_IMAGE";
export const TEXTUAL_SEARCH_OBJECT = "TEXTUAL_SEARCH_OBJECT";
export const VISUAL_SEARCH = "VISUAL_SEARCH";
export const EXPLORATION_STATS = "EXPLORATION_STATS";
export const DATA_METADATA_SUMMARY = "DATA_METADATA_SUMMARY";
export const FIND_SIMILAR_OBJECT_FILTER = "FIND_SIMILAR_OBJECT";
export const SHOW_DS_VERSION = "SHOW_DS_VERSION";
export const ENABLE_DS_DUPLICATE = "ENABLE_DS_DUPLICATE";

export const AUTO_SUGGEST_RECENT_SEARCH = "AUTO_SUGGEST_RECENT_SEARCH";
export const AUTO_SUGGEST_QUERY = "AUTO_SUGGEST_QUERY";

export const REGION_SELECTION_SIMILARITY = "REGION_SELECTION_SIMILARITY";
export const DATA_INGESTION_TAB_AVAILABLE = "DATA_INGESTION_TAB_AVAILABLE";
export const USAGE_REPORT = "USAGE_REPORT";
export const DELETE_DATASET = "DELETE_DATASET";
export const EXPLORATION_DEBUG_INFO = "EXPLORATION_DEBUG_INFO";
export const DATASET_SHARE = "DATASET_SHARE";
export const CVAT_INTEGRATION = "CVAT_INTEGRATION";
export const CLUSTER_BY_DUPLICATES = "CLUSTER_BY_DUPLICATES";
export const UNIQUENESS_SCORE = "UNIQUENESS_SCORE";
export const PROMPT_SUPPORT_ENABLED = "PROMPT_SUPPORT_ENABLED";
export const MISLABEL_CONFIDENCE_FILTER_FOR_OBJECTS =
  "MISLABEL_CONFIDENCE_FILTER_FOR_OBJECTS";
export const MISLABEL_CONFIDENCE_FILTER_FOR_IMAGES =
  "MISLABEL_CONFIDENCE_FILTER_FOR_IMAGES";
export const DYNAMIC_TEXTUAL_SIMILARITY_THRESHOLD =
  "DYNAMIC_TEXTUAL_SIMILARITY_THRESHOLD";
export const ENRICHMENT_ENRICH_DATASET = "ENRICHMENT_ENRICH_DATASET";
export const TEXTUAL_SEARCH_RELEVANCE_SCORE_OBJECTS =
  "TEXTUAL_SEARCH_RELEVANCE_SCORE_OBJECTS";
export const TEXTUAL_SEARCH_RELEVANCE_SCORE_IMAGES =
  "TEXTUAL_SEARCH_RELEVANCE_SCORE_IMAGES";
export const FLYWHEEL = "FLYWHEEL";
export const TRAIN_WORTHY = "TRAIN_WORTHY";
export const TRAIN_MODEL = "TRAIN_MODEL";
export const ADD_MEDIA = "ADD_MEDIA";
export const EXPLORATION_PERFORMANCE = "EXPLORATION_PERFORMANCE";
export const DATASET_SNAPSHOTS = "DATASET_SNAPSHOTS";
export const NEW_STATUS = "NEW_STATUS";
export const ADD_MEDIA_TAB = "ADD_MEDIA_TAB";
export const USER_MANAGEMENT = "USER_MANAGEMENT";
export const CAPTIONS_FILTER = "CAPTIONS_FILTER";
export const IMAGE_DISPLAY = "IMAGE_DISPLAY";
export const DATASET_SNAPSHOTS_CREATE = "DATASET_SNAPSHOTS_CREATE";
export const DATASET_SNAPSHOTS_RESTORE = "DATASET_SNAPSHOTS_RESTORE";
